import * as React from "react";

function FlagUsaIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M508.3 0c-6.365 0-13.04 1.35-19.37 4.232-45.69 20.86-79.56 27.94-107.8 27.94-59.96 0-94.8-31.86-163.9-31.87-34.63 0-77.87 8.002-137.2 32.04V24C80 10.75 69.26 0 56 0 42.75 0 32 10.75 32 24v464c0 13.3 10.75 24 24 24 13.26 0 24-10.75 24-24V384c53.59-23.86 96.02-31.81 132.8-31.81 73.63 0 124.9 31.78 198.6 31.78 31.91 0 68.02-5.973 111.1-23.09 13.6-5.08 21.5-16.48 21.5-28.78V30.74C544 12.01 527.3 0 508.3 0zM184 32c8.836 0 16 7.164 16 16s-7.2 16-16 16-16-7.164-16-16 7.2-16 16-16zm0 56c8.836 0 16 7.164 16 16s-7.164 16-16 16-16-7.164-16-16 7.2-16 16-16zm-64-40c8.836 0 16 7.164 16 16s-7.164 16-16 16-16-7.16-16-16 7.2-16 16-16zm0 64c8.836 0 16 7.164 16 16s-7.164 16-16 16-16-7.2-16-16 7.2-16 16-16zm376 207.8c-30.31 10.82-58.08 16.1-84.6 16.1-30.8 0-58.31-7-87.44-14.41-32.01-8.141-68.29-17.37-111.1-17.37-42.35 0-85.99 9.09-132.8 27.73V283.8l18.03-7.301C145.4 257.3 184.4 248 217.2 248c28.24.004 49.13 6.711 73.31 14.48 25.38 8.148 54.13 17.39 90.58 17.39 35.43 0 72.24-8.496 114.9-26.61v66.54zm0-118.2c-2.371.656-4.75 1.289-7.072 2.344-45.69 20.86-79.56 27.94-107.8 27.94-59.96 0-94.8-31.86-163.9-31.87C182.6 200 139.3 208 80 232.1v-44.3l18.03-7.301C145.4 161.3 184.4 152 217.2 152c28.24.004 49.13 6.711 73.31 14.48 25.38 8.148 54.13 17.39 90.58 17.39 35.43 0 72.24-8.496 114.9-26.61v44.34zm0-96c-2.371.656-4.75 1.289-7.072 2.344-45.69 20.86-79.56 27.94-107.8 27.94-52.97 0-86.42-24.78-141.1-30.59V49.96c17.7 2.422 33.32 7.297 50.52 12.82 25.38 8.148 54.13 17.39 90.58 17.39 35.43 0 72.24-8.496 114.9-26.61v52.04z"
  }));
}

const ForwardRef = React.forwardRef(FlagUsaIcon);
export default ForwardRef;